import gql from 'graphql-tag';

const DELETE_LIST = gql`
  mutation RemoveList($input: RemoveListInput) {
    removeList(input: $input) {
      list {
        name
        public
      }
    }
  }
`;

export default DELETE_LIST;
